export enum SeverityTypesEnum {
  bland = 1,
  medium = 2,
  severe = 3,
  notInformed = 99
}

export enum AlarmEventInterval {
  LastDay = 1,
  LastWeek = 2,
  LastMonth = 3,
}

export type AlarmDetails = {
  code: string;
  name: string | null;
  type: string;
  severity: SeverityTypesEnum;
  message: string | null;
  causes: string | null;
  solutions: string | null;
  startDate: string | null;
  actions: {
    specializedTechnical: string | null;
    technicalAssistance: string | null;
    openServiceRequest: string | null;
    inspectionProcedure: string | null;
    oscillography: string | null;
    dealership: string | null;
    provider: string | null;
    hasInspectionProcedure: boolean;
    inspectionProcedureName: string | null;
  };
};

export type CurrentAlarms = {
  ugCurrentAreas: {
    ug: string;
    areasAlarms: AreaTypeAlarm[];
  }[];
};

export type AreaTypeAlarm = {
  areaType: string;
  alarmAreas: AreaAlarm[]
}

export type AreaAlarm = {
  area: string;
  alarmEvents: AlarmEvent[]
}

export type TimeObject = {
  days?: number;
  hours?: string;
};

export type AlarmTimeline = {
  alarmEventGroups: alarmEventGroup[] | null;
  currentIdSS: number | null;
  alarmIsActive: boolean | null;
  alarmLastActiveDate: Date | null;
};

export type alarmEventGroup = {
  stringName: string;
  currentAlarmEvent: AlarmTimelineEvent;
  activeTime: TimeObject | null;
  alarmTimeLineList: AlarmTimelineEvent[]
}

export type AlarmTimelineEvent = {
  id: string;
  startDateTime: Date;
  endDateTime: Date | null;
  message: string | null;
  active: boolean;
  duration: string | null;
  createdAt: Date;
  idSS: number | null;
  groupType: string | null;
}

export type AlarmEvent = {
  id: string;
  code: string;
  startDate: Date;
  endDate: Date;
  usinaId: number;
  usinaName: string;
  area: string;
  ug: string;
  message: string;
  active: boolean;
  duration: string;
  createdAt: Date;
  severity: SeverityTypesEnum;
  idSS: number | null;
};
